module.exports = __webpack_public_path__ + "img/pro5.f8ee2e5b.png";